/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TextSnippetVisibilityEnum } from './textSnippetVisibilityEnum';
import { TextSnippetPermissions } from './textSnippetPermissions';
import { TextSnippetOwner } from './textSnippetOwner';


/**
 * A row of the list and of the insert dropdown; the content follows on demand.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TextSnippetList { 
    readonly id: number;
    readonly title: string;
    readonly tags: Array<string>;
    readonly visibility: TextSnippetVisibilityEnum;
    readonly owner: TextSnippetOwner | null;
    readonly practice: number | null;
    readonly practiceName: string | null;
    readonly preview: string;
    readonly permissions: TextSnippetPermissions;
    readonly updatedAt: string | null;
}
export namespace TextSnippetList {
}

export const TextSnippetList_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_title_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_tags_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_visibility_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_owner_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_practice_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_practiceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_preview_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_permissions_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetList_updatedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];


